var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { staticClass: "pa-1", attrs: { fluid: "" } }, [
    _c(
      "div",
      [
        _c(
          "v-row",
          [
            _c(
              "v-col",
              { attrs: { cols: "12" } },
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.$t("delegation.form.listOfAttachments")) + ":"
                  )
                ]),
                _vm.delegation.file.length === 0
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("delegation.form.noAttachments")) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _vm._l(_vm.delegation.file, function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _c(
                        "v-card",
                        {
                          class: {
                            "green accent-1":
                              item.uploadedSize === item.fileSize
                          }
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "10" } },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticStyle: {
                                                "min-width": "40px",
                                                "max-width": "50px"
                                              },
                                              attrs: { cols: "1" }
                                            },
                                            [
                                              item.category === "transport"
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        "x-large":
                                                                          ""
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " directions_transit "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "delegation.form.fileAttachmentDescription.transport"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.category === "accommodation"
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        "x-large":
                                                                          ""
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " hotel "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "delegation.form.fileAttachmentDescription.accommodation"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.category === "attachment"
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        "x-large":
                                                                          ""
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " attach_file "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "delegation.form.fileAttachmentDescription.manuallyAdded"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.category === "otherSummary"
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        "x-large":
                                                                          ""
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " attach_file "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "delegation.form.fileAttachmentDescription.otherGeneral"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "11" } },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    "word-wrap": "break-word"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.itemName))]
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    Number.parseFloat(
                                                      item.fileSize / 1000
                                                    ).toFixed(1)
                                                  ) +
                                                  " KB) " +
                                                  _vm._s(item.status) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    { staticClass: "text-right" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.$store
                                                                .getters[
                                                                "Ajax/loading"
                                                              ],
                                                            icon: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.downloadFile(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            "cloud_download"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("global.downloadFile")
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _vm.$store.state.Delegation
                                                      .readonly !== true
                                                      ? _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  item.category !==
                                                                    "attachment" ||
                                                                  _vm.$store
                                                                    .getters[
                                                                    "Ajax/loading"
                                                                  ],
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeFile(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v("close")
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.category !== "attachment"
                                                  ? _vm.$t(
                                                      "delegation.form.canNotRemoveAttachmentAtItem"
                                                    )
                                                  : _vm.$t("global.removeFile")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              item.uploadedSize !== item.fileSize
                                ? _c("v-progress-linear", {
                                    attrs: {
                                      value:
                                        (item.uploadedSize / item.fileSize) *
                                        100
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _vm.$store.state.Delegation.readonly !== true
                  ? _c(
                      "v-row",
                      [
                        _c("v-col", { staticClass: "my-3" }, [
                          _c(
                            "form",
                            { ref: "inputForm" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.fileInput.click()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("global.addFile")))]
                              ),
                              _vm.uploadButton
                                ? _c("input", {
                                    ref: "fileInput",
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      type: "file",
                                      accept:
                                        _vm.$store.getters[
                                          "Delegation/allowedAttachmentFileFormat"
                                        ]
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.upload($event)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _c(
              "v-col",
              { attrs: { cols: "12" } },
              [
                _c("booking-and-invoices", {
                  attrs: {
                    readonly: _vm.$store.state.Delegation.readonly === true
                  }
                })
              ],
              1
            ),
            _c(
              "v-col",
              { staticStyle: { "margin-top": "20px" }, attrs: { cols: "12" } },
              [
                _c("CollapseOtherSummaryPanel", {
                  attrs: {
                    "model-other": _vm.delegation.other,
                    readonly: _vm.$store.state.Delegation.readonly === true,
                    clearable: _vm.$store.state.Delegation.readonly !== true
                  }
                })
              ],
              1
            ),
            _c(
              "v-col",
              { staticStyle: { "margin-top": "20px" }, attrs: { cols: "12" } },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("global.summary")))]),
                _vm.transportOtherThanDelegationOrderRestrictions
                  ? _c("div", [
                      _c("span", [
                        _c("b", { staticClass: "red--text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "delegation.form.differentTransportWarning"
                              )
                            ) + " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("delegation.form.estimatedTransportCost")) +
                      ": "
                  ),
                  _c("span", [
                    _c(
                      "b",
                      {
                        class: {
                          "green--text": !_vm.transportCostExceeded,
                          "red--text": _vm.transportCostExceeded
                        }
                      },
                      [_vm._v(_vm._s(_vm.transportCost))]
                    )
                  ]),
                  _vm.transportCostExceeded
                    ? _c("span", { staticClass: "red--text" }, [
                        _c("b", [
                          _vm._v(
                            " (" +
                              _vm._s(
                                _vm.$t("global.error.transportLimitExceeded")
                              ) +
                              ")"
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("delegation.form.estimatedAccommodationCost")
                      ) +
                      ": "
                  ),
                  _c("span", [
                    _c(
                      "b",
                      {
                        class: {
                          "green--text": !_vm.accommodationCostExceeded,
                          "red--text": _vm.accommodationCostExceeded
                        }
                      },
                      [_vm._v(_vm._s(_vm.accommodationCost))]
                    )
                  ]),
                  _vm.accommodationCostExceeded
                    ? _c("span", { staticClass: "red--text" }, [
                        _c("b", [
                          _vm._v(
                            " (" +
                              _vm._s(
                                _vm.$t("global.error.hotelLimitExceeded")
                              ) +
                              ")"
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("delegation.form.estimatedDietCost")) +
                      ": "
                  ),
                  _c("span", [
                    _c("b", { staticClass: "green--text" }, [
                      _vm._v(_vm._s(_vm.countryCost))
                    ])
                  ])
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("delegation.form.estimatedOtherCost")) +
                      ": "
                  ),
                  _c("span", [
                    _c("b", { staticClass: "green--text" }, [
                      _vm._v(_vm._s(_vm.otherCost))
                    ])
                  ])
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("delegation.form.estimatedAdvance")) +
                      ": "
                  ),
                  _c("span", [
                    _c("b", { staticClass: "green--text" }, [
                      _vm._v(_vm._s(_vm.payedAdvances))
                    ])
                  ])
                ]),
                _c("div", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("delegation.form.estimatedReturnToDelegated")
                      ) + ": "
                    )
                  ]),
                  _c("span", [
                    _c("b", { staticClass: "green--text" }, [
                      _vm._v(_vm._s(_vm.returnToWorkerCost))
                    ])
                  ])
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }